import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

export default function AdminRoute() {
  const { user } = useAuthStore();
  const isAdmin = user?.globalRole === 'ADMIN' || user?.globalRole === 'SUPER_ADMIN';
  return isAdmin ? <Outlet /> : <Navigate to="/" replace />;
}
